import React from "react";
import "./ProjectIcon.css"

const ProjectIcon = (props) => {
    return(
        <div onClick={() => props.setProject(props.project)} className="skillsIcon">
            <img src={props.project.icon} alt="" />
            <p>{props.project.name}</p>
        </div>
    )
}

export default ProjectIcon